
<template> 
  <div class="pioneer-list-page">
    <div class="page-body">
      <div class="search-bar">
        <el-form :model="searchForm" :inline="true" size="small" class="search-form">
          <el-form-item label="标段名称">
            <el-input v-model="searchForm.sectionName" placeholder="请输入" clearable style="width: 260px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="primary" @click="openAddDialog">添加现场踏勘通知</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-area">
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          :header-cell-style="{ background: '#fafafa', color: '#333', fontWeight: '600' }"
        >
          <el-table-column type="index" label="编号" width="70" align="center" />
          <el-table-column prop="sectionName" label="标段名称" min-width="220" show-overflow-tooltip />
          <el-table-column prop="surveyCode" label="踏勘编码" min-width="140" show-overflow-tooltip />
          <el-table-column prop="surveyPlace" label="踏勘地点" min-width="160" show-overflow-tooltip />
          <el-table-column prop="surveyStartTime" label="踏勘开始时间" min-width="170" />
          <el-table-column prop="contactPerson" label="联系人" min-width="120" />
          <el-table-column prop="contactPhone" label="联系电话" min-width="140" />
          <el-table-column prop="sendTime" label="发出通知时间" min-width="170" />
          <el-table-column prop="detail" label="详细信息" min-width="220" show-overflow-tooltip />
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleViewDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-bar">
        <el-pagination
          background
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="addDialogVisible"
      width="860px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="simple-dialog"
    >
      <div slot="title" class="dialog-title">
        <span>添加现场踏勘通知</span>
        <!-- <el-button type="text" class="dialog-back" @click="closeAddDialog">返回</el-button> -->
      </div>

      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="addRulesEnabled ? addRules : {}"
        label-width="140px"
        size="small"
        class="dialog-form"
      >
        <el-form-item label="相关标段" prop="sectionName">
          <el-input v-model="addForm.sectionName" placeholder="请输入标段名称" clearable />
        </el-form-item>

        <el-form-item label="踏勘地点" prop="surveyPlace">
          <el-input v-model="addForm.surveyPlace" placeholder="请输入" clearable />
        </el-form-item>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="开始时间" prop="surveyStartTime">
              <app-date-picker
                v-model="addForm.surveyStartTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择时间"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发出通知时间" prop="sendTime">
              <app-date-picker
                v-model="addForm.sendTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择时间"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="addForm.contactPerson" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="addForm.contactPhone" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="通知内容" prop="noticeContent">
          <el-input
            v-model="addForm.noticeContent"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submitLoading" @click="handleAddSubmit('submit')">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="详情"
      :visible.sync="detailDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form label-width="140px" size="small">
        <el-form-item label="标段名称">
          <span>{{ detailData.sectionName }}</span>
        </el-form-item>
        <el-form-item label="踏勘编码">
          <span>{{ detailData.surveyCode }}</span>
        </el-form-item>
        <el-form-item label="踏勘地点">
          <span>{{ detailData.surveyPlace }}</span>
        </el-form-item>
        <el-form-item label="踏勘开始时间">
          <span>{{ detailData.surveyStartTime }}</span>
        </el-form-item>
        <el-form-item label="发出通知时间">
          <span>{{ detailData.sendTime }}</span>
        </el-form-item>
        <el-form-item label="联系人">
          <span>{{ detailData.contactPerson }}</span>
        </el-form-item>
        <el-form-item label="联系电话">
          <span>{{ detailData.contactPhone }}</span>
        </el-form-item>
        <el-form-item label="详细信息">
          <span>{{ detailData.detail }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getBuildSurveyList, addBuildSurvey } from '@/api/agent/api'
export default {
  name: 'PioneerList',
  data() {
    return {
      loading: false,
      submitLoading: false,
      searchForm: {
        sectionName: ''
      },
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addDialogVisible: false,
      addRulesEnabled: false,
      detailDialogVisible: false,
      detailData: {},
      addForm: {
        sectionName: '',
        surveyPlace: '',
        surveyStartTime: '',
        sendTime: '',
        contactPerson: '',
        contactPhone: '',
        noticeContent: ''
      },
      addRules: {
        sectionName: [{ required: true, message: '请输入相关标段', trigger: 'blur' }],
        surveyPlace: [{ required: true, message: '请输入踏勘地点', trigger: 'blur' }],
        surveyStartTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        sendTime: [{ required: true, message: '请选择发出通知时间', trigger: 'change' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        noticeContent: [{ required: true, message: '请输入通知内容', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchList()
    },
    handleReset() {
      this.searchForm.sectionName = ''
      this.pagination.pageNum = 1
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.fetchList()
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await getBuildSurveyList({
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          sectionName: this.searchForm.sectionName
        })
        
        if (res.code === 200) {
          this.tableData = res.data.list || []
          this.pagination.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '获取列表失败')
          this.tableData = []
          this.pagination.total = 0
        }
      } catch (error) {
        this.$message.error('获取列表失败，请稍后重试')
        this.tableData = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    openAddDialog() {
      this.addDialogVisible = true
      this.addRulesEnabled = false
      this.resetAddForm()
    },
    closeAddDialog() {
      this.addDialogVisible = false
    },
    resetAddForm() {
      this.addForm = {
        sectionName: '',
        surveyPlace: '',
        surveyStartTime: '',
        sendTime: '',
        contactPerson: '',
        contactPhone: '',
        noticeContent: ''
      }
      this.$nextTick(() => {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.clearValidate()
        }
      })
    },
    async handleAddSubmit(action) {
      if (this.submitLoading) return
      this.submitLoading = true
      try {
        this.addRulesEnabled = true
        await this.$nextTick()
        const valid = await new Promise(resolve => {
          this.$refs.addFormRef.validate(ok => resolve(ok))
        })
        if (!valid) return

        // 构建接口参数
        const payload = {
          sectionName: this.addForm.sectionName,
          surveyPlace: this.addForm.surveyPlace,
          surveyStartTime: this.addForm.surveyStartTime,
          sendTime: this.addForm.sendTime,
          contactPerson: this.addForm.contactPerson,
          contactPhone: this.addForm.contactPhone,
          detail: this.addForm.noticeContent
        }

        const res = await addBuildSurvey(payload)
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.closeAddDialog()
          this.fetchList()
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      } catch (error) {
        this.$message.error('操作失败，请稍后重试')
      } finally {
        this.submitLoading = false
      }
    },
    handleViewDetail(row) {
      this.detailData = { ...row }
      this.detailDialogVisible = true
    }
  }
}
</script>

<style scoped>
.pioneer-list-page {
  padding: 16px;
}

.page-body {
  background: #fff;
}

.search-bar {
  padding: 12px 12px 0 12px;
}

.search-form ::v-deep .el-form-item {
  margin-bottom: 12px;
}

.table-area {
  max-height: calc(100vh - 260px);
  padding: 0 12px;
}

.pagination-bar {
  padding: 12px;
  display: flex;
  justify-content: flex-end;
}

.dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog-back {
  padding: 0;
}

.dialog-form {
  padding-top: 4px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}
</style>